<svg xmlns="http://www.w3.org/2000/svg" width="120" height="121" viewBox="0 0 120 121">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path stroke="#313131" stroke-width="1.5" d="M18.667 120c8.878 0 16.227-6.488 17.478-14.939.083-.557.146-1.41.188-2.561H54V85H18.667C8.91 85 1 92.835 1 102.5S8.91 120 18.667 120z"/>
        <path fill="url(#a)" d="M0 0h76v120H0z" transform="translate(44)"/>
        <path fill="#FFF" d="M104.033 60.5s.835 9.92-6.81 15.04c0 0 14.968-29.568-17.02-47.04 0 0 4.495 7.616-6.039 16.768-8.8 7.616-29.74 32.768 1.028 47.232 0 0-12.461-16.256 3.02-25.216 0 0-5.91 9.472 4.688 17.472 6.295-6.528 4.625-9.856 4.625-9.856s9.121 7.296 2.377 17.6c0 0 25.629-6.144 14.131-32" opacity=".65"/>
    </g>
</svg>
